"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appIcon = function appIcon(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: require("../assets/logos/".concat(icon, ".svg")),
    alt: "logo"
  }));
};

appIcon.propTypes = {
  icon: _propTypes.default.string.isRequired
};
var _default = appIcon;
exports.default = _default;